import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { AdminWithdrawalsRequest, AdminWithdrawalUpdateRequest } from "./api";
import { getAdminWithdrawals, updateAdminWithdrawal } from "./slice";

export const useAdminWithdrawals = () => {
  const state = useAppSelector((state) => state.adminWithdrawals);
  const dispatch = useAppDispatch();

  const getAdminWithdrawalsHandler = useCallback(
    (data?: AdminWithdrawalsRequest) => dispatch(getAdminWithdrawals({ data })),
    [dispatch]
  );

  const updateAdminWithdrawalHandler = useCallback(
    (withdrawalId: string, data: AdminWithdrawalUpdateRequest) =>
      dispatch(updateAdminWithdrawal({ withdrawalId, data })),
    [dispatch]
  );

  return {
    state,
    getAdminWithdrawals: getAdminWithdrawalsHandler,
    updateAdminWithdrawal: updateAdminWithdrawalHandler,
  };
};
